import React, { useState } from "react";

export default function Booking({ planes }) {
  const [search, setSearch] = useState({
    departure: "",
    destination: ""
  });
  const [filteredPlanes, setFilteredPlanes] = useState([]);
  const [showPaymentCard, setShowPaymentCard] = useState(false);

  function handleChange(event) {
    const { name, value } = event.target;
    setSearch((prevState) => ({ ...prevState, [name]: value }));
  }

  function handleSubmit(e) {
    e.preventDefault();
    console.log(search);

    const filteredPlanes = planes.filter(
      (plane) =>
        plane.departure.toLowerCase() === search.departure.toLowerCase() &&
        plane.destination.toLowerCase() === search.destination.toLowerCase()
    );

    setFilteredPlanes(filteredPlanes);
  }


  function handleClick() {
    // Find the selected plane
    const selectedPlane = filteredPlanes[0];

    // Reduce the capacity by 1
    const updatedPlane = {
      ...selectedPlane,
      capacity: selectedPlane.capacity - 1
    };

    // Send PATCH request to update the capacity
    
    fetch(`https://flask-api-dlzd.onrender.com/aircrafts/${selectedPlane.id}`, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(updatedPlane)
    })
      .then((response) => response.json())
      .then((data) => {
        console.log("Booking successful");
        setShowPaymentCard(true);
      })
      .catch((error) => {
        console.log("Booking failed", error);
      });
  }

  return (
    <>
      <div className="booking-form">
        <h1>Book Your Flight</h1>
        <p>*we only offer flights from Nairobi to limited destinations</p>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="departure">Departure</label>
            <input
              type="text"
              id="departure"
              placeholder="Enter departure city"
              name="departure"
              value={search.departure}
              onChange={handleChange}
            />
          </div>
          <div className="form-group">
            <label htmlFor="destination">Destination</label>
            <input
              type="text"
              id="destination"
              placeholder="Enter destination city"
              name="destination"
              value={search.destination}
              onChange={handleChange}
            />
          </div>
          <div className="form-group">
            <button type="submit">Search Flights</button>
          </div>
        </form>
      </div>

      <div className="cards-container">
        {filteredPlanes.length > 0 &&
          filteredPlanes.map((plane) => (
            <div className="card2" key={plane.id}>
              <img src={plane.image} alt="Airplane" className="card-image" />
              <div className="card-content">
                <p className="airline2">Airline: {plane.airline}</p>
                <p className="aircraft-model2">Aircraft Model: {plane.aircraft_model}</p>
                <p className="capacity2">Capacity: {plane.capacity}</p>
                <p className="departure2">Departure: {plane.departure}</p>
                <p className="destination2">Destination: {plane.destination}</p>
                <p className="flight-duration2">Flight Duration: {plane.flight_duration}</p>
                <button style={{ backgroundColor: "black" }} onClick={handleClick}>
                  Book Now
                </button>
              </div>
            </div>
          ))}
      </div>

      {showPaymentCard && (
        <div className="payment-card">
            <h1>Booking was a success See You In the Sky</h1>   
        </div>
      )}
    </>
  );
}
